import { MessageCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMessageUnreadCount } from '@/hooks/useMessages';
import { cn } from '@/lib/utils';

export default function MessagesIcon() {
  const { t } = useTranslation();
  const unreadCount = useMessageUnreadCount();
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate('/messages')}
      className="relative p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-accent transition-colors"
      title={t('messaging.title')}
      aria-label={t('messaging.title')}
    >
      <MessageCircle className={cn("h-5 w-5", unreadCount > 0 && "text-foreground")} />
      {unreadCount > 0 && (
        <span
          className={cn(
            'absolute -top-0.5 -right-0.5 flex items-center justify-center',
            'rounded-full bg-red-500 text-white text-dense font-bold',
            unreadCount > 9 ? 'h-5 w-5 text-caption' : 'h-4 w-4'
          )}
        >
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  );
}
